import React, { useContext } from 'react';
import '@nextiva/next-ui-wayfinder/dist/styles.css';
import { FeatureContext } from '../AccessResolvers/featureContext';

import Wayfinder from './Wayfinder/Wayfinder';

export const SideNav = () => {
  const {
    featureState: { bulkImports, isClusterIdInBWPatching },
  } = useContext(FeatureContext);

  const routeHandler = (routes) => {
    // IN APP route handler (modify displayed links)
    if (isClusterIdInBWPatching) {
      const communicationRoute = routes.find(
        (route) => route.label === 'Communication',
      );

      if (communicationRoute) {
        const index = communicationRoute.links.findIndex(
          (route) => route.label === 'Voice',
        );

        if (index > -1) {
          communicationRoute.links.splice(index, 1);
        }
      }
    }

    if (bulkImports) {
      const dataImport = routes
        .find((route) => route.label === 'Advanced Settings')
        ?.links.find((link) => link.label === 'Data import');

      if (dataImport) {
        dataImport.defaultRoute = '/apps/platform-admin/#/data-import';
      }
    }

    return routes;
  };

  return <Wayfinder routeHandler={routeHandler} />;
};
